export default {"src":"/pro/_next/static/media/useless.cb932c6f.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};